// extracted by mini-css-extract-plugin
module.exports = {"modalFooterButtons":"ProductMeasureEditionModal_modalFooterButtons__2xq0J"};